module.exports = __webpack_public_path__ + "img/6.157f8062.jpg";